import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from '../Field.module.scss';
import { InfoFieldProps } from '../../../../../types/props';
import { useWidth } from '../../../../../hooks/useWidth';

export const LinkField: React.FC<InfoFieldProps> = ({ name, content, style }) => {
    const [isSelected, setIsSelected] = React.useState(false);
    const width = useWidth();
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isSelected && inputRef.current) {
            const input = inputRef.current;
            input.focus();

            const length = input.value.length;
            input.setSelectionRange(length, length);

            input.scrollLeft = input.scrollWidth;
        }
    }, [isSelected]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
                setIsSelected(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div
            className={classNames(styles.infoField, {
                [styles.selected]: isSelected && width < 1024,
            })}
            style={style}
            onClick={() => {
                if (width < 1024) setIsSelected(true);
            }}
        >
            <span className={styles.name}>{name}</span>
            <div style={{ width: '100%', overflow: 'auto' }}>
                {width < 1024 ? (
                    <input
                        ref={inputRef}
                        className={classNames(styles.content, styles.contentLink)}
                        value={content}
                        inputMode="url"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                    />
                ) : (
                    <span className={classNames(styles.content, styles.contentLink)}>
                        {content}
                    </span>
                )}
            </div>
        </div>
    );
};
